module.exports = __webpack_public_path__ + "static/media/specimen_original.6e935108.png";